import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenInterceptor } from './token.interceptor';
import { UniversalInterceptor } from './universal.interceptor';

export * from './token.interceptor';
export * from './universal.interceptor';

export const SHARED_INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UniversalInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  },
];
